import * as React from 'react';
import { Microfrontend } from '@cian/mf-react';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';

import { useSelector } from 'react-redux';
import { Layout } from '../../components/Layout';
import { MORTGAGE_MINI_CALCULATOR_MF_NAME } from '../../constants/microfrontends';
import { getNewbuildingOfferType, getRegionId } from '../../selectors/newbuilding';
import { mortgageSeoPageUrlSelector } from '../../selectors/seoPages';

import { EOfferTypes } from '../../types/offers';
import { useApplicationContext } from '../../utils/withApplicationContext';
import { getIsRealtor } from '../../selectors/newbuilding/getIsRealtor';

export const MortgageMiniCalculatorWidget = () => {
  const { config } = useApplicationContext();
  const isRealtor = useSelector(getIsRealtor);
  const regionId = useSelector(getRegionId);
  const newbuildingOfferType = useSelector(getNewbuildingOfferType);
  const url = useSelector(mortgageSeoPageUrlSelector);
  const manifest = config.get<IMicrofrontendManifest>(`microfrontendManifests.${MORTGAGE_MINI_CALCULATOR_MF_NAME}`);
  const mortgageMiniCalculatorEnabled = config.get<boolean>('Newbuilding.MortgageMiniCalculator.Enabled');

  if (!manifest || !mortgageMiniCalculatorEnabled || isRealtor) {
    return null;
  }

  const objectType = newbuildingOfferType === EOfferTypes.ApartmentOnly ? 'apartments' : 'flat';

  return (
    <Layout>
      <Microfrontend
        name={manifest.microfrontendName}
        image={manifest.imageVersion}
        runtime={manifest.runtimeName}
        parameters={{
          defaultFormState: {
            objectType,
            realEstateType: 'newBuilding',
            regionId,
            newbuildingSeoLinkUrl: url,
          },
        }}
        instance={manifest.instanceId}
      />
    </Layout>
  );
};
